/**
 * Environment Detection Utilities
 * 
 * Helps detect deployment environment and adjust behavior accordingly
 */

/**
 * Check if app is running on Vercel
 */
export const isVercelDeployment = (): boolean => {
  return !!(
    typeof window !== 'undefined' && (
      window.location.hostname.includes('vercel.app') ||
      window.location.hostname.includes('canvango.vercel.app') ||
      import.meta.env.VITE_VERCEL === '1'
    )
  );
};

/**
 * Check if app is in development mode
 */
export const isDevelopment = (): boolean => {
  return import.meta.env.DEV;
};

/**
 * Check if app is in production mode
 */
export const isProduction = (): boolean => {
  return import.meta.env.PROD;
};

/**
 * Get environment-specific timeout values
 */
export const getEnvironmentTimeouts = () => {
  const base = {
    auth: 15000,      // 15s base auth timeout
    profile: 20000,   // 20s base profile timeout
    session: 15000,   // 15s base session timeout
  };

  // Increase timeouts for Vercel deployment due to cold starts
  if (isVercelDeployment()) {
    return {
      auth: base.auth * 1.5,      // 22.5s
      profile: base.profile * 1.5, // 30s
      session: base.session * 1.5, // 22.5s
    };
  }

  // Use base timeouts for local development and other deployments
  return base;
};

/**
 * Get deployment info for debugging
 */
export const getDeploymentInfo = () => {
  return {
    isVercel: isVercelDeployment(),
    isDev: isDevelopment(),
    isProd: isProduction(),
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'unknown',
    timeouts: getEnvironmentTimeouts(),
  };
};